/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
import Service from './servece.js';
// component
import Navbar from '../../../components/navbar/index.vue';
import ProductService from '../../home/product-service/index.vue';
import contactUs from '../../home/contact-us/index.vue';
export default {
  name: 'home',
  components: {
    Navbar,
    ProductService,
    contactUs
  },
  data() {
    return {
      fromisActiveClass: 'newsCenter',
      id: '',
      guanWang: '',
      details: {}
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.guanWang = this.$route.query.guanWang;
    this.getNewsDetail(this.id, this.guanWang);
  },

  methods: {
    getNewsDetail(id, guanWang) {
      Service.getNewsDetail(id, guanWang).then(res => {
        this.details = {
          ...res.data
        };
      });
    }
  }
};
